import type { PlainDate } from "@sa-nu/shared-utils/date";

const DAY_OF_WEEK_CHAR = ["日", "月", "火", "水", "木", "金", "土", "日"];

function formatDateWithDayOfWeek(date: PlainDate): string {
  return `${date.month}/${date.day}(${DAY_OF_WEEK_CHAR[date.dayOfWeek]})`;
}

/**
 * "M/D(曜日) - M/D(曜日)・N泊" 形式。formatPlainDate は曜日の前にスペースを入れる
 * (例: "12/21 (土)") ため使えない。
 */
export function formatStayScheduleLabel(
  checkInDate: PlainDate,
  checkOutDate: PlainDate,
): string {
  const nights = checkInDate.until(checkOutDate).total({ unit: "day" });
  return `${formatDateWithDayOfWeek(checkInDate)} - ${formatDateWithDayOfWeek(checkOutDate)}・${nights}泊`;
}
